import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import { ChangeDetectorRef, EventEmitter, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DEFAULT_4_POSITIONS, POSITION_MAP } from '../core/overlay/overlay-position-map';
import { isNotNil } from '../core/util/check';
import { toBoolean } from '../core/util/convert';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
var ThemeComponent = /** @class */ (function () {
    // ** end */
    function ThemeComponent(cdr, http) {
        var _this = this;
        this.cdr = cdr;
        this.http = http;
        this._hasBackdrop = false;
        this._prefix = 'ant-popover-placement';
        this._positions = DEFAULT_4_POSITIONS.slice();
        this._classMap = {};
        this._trigger = 'click';
        this.visibleSource = new BehaviorSubject(false);
        this.visible$ = this.visibleSource.asObservable();
        this.dwVisibleChange = new EventEmitter();
        this.dwOverlayClassName = '';
        this.dwOverlayStyle = {};
        this.dwMouseEnterDelay = 0.15; // Unit: second
        this.dwMouseLeaveDelay = 0.1; // Unit: second
        // ** 自訂for theme component 屬性 */
        this._dwPopWidth = 80;
        this._dwColorColSplit = 2;
        this.dwShowDesc = false;
        this.listWidth = this.dwPopWidth / this.dwColorColSplit;
        this.prefix = 'customTheme-';
        this.nowThemeStyleId = 'default';
        this._themeList = [{ id: 'default', path: 'default', description: '預設樣式' }];
        this.defaultTheme = { id: 'default', path: 'default', description: '預設樣式' };
        this.http.get('assets/themes/themeJson.json')
            .pipe(map(function (res) {
            res.forEach(function (i) {
                var id = i.id;
                i.description = id;
                switch (id) {
                    case id = 'theme-green':
                        i.description = '樣式-green';
                        break;
                    case id = 'theme-red':
                        i.description = '樣式-red';
                        break;
                    case id = 'theme-yellow':
                        i.description = '樣式-yellow';
                        break;
                    case id = 'theme-white':
                        i.description = '樣式-white';
                        break;
                    default:
                        break;
                }
            });
            return res;
        }))
            .subscribe(function (res) {
            _this.themeList = _this.themeList.concat(res);
        });
    }
    Object.defineProperty(ThemeComponent.prototype, "dwContent", {
        get: function () {
            return this.dwTemplate;
        },
        set: function (value) {
            this.isContentString = !(value instanceof TemplateRef);
            this.dwTemplate = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThemeComponent.prototype, "dwTitle", {
        get: function () {
            return this._title;
        },
        set: function (value) {
            this.isTitleString = !(value instanceof TemplateRef);
            this._title = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThemeComponent.prototype, "dwVisible", {
        get: function () {
            return this.visibleSource.value;
        },
        set: function (value) {
            var visible = toBoolean(value);
            if (this.visibleSource.value !== visible) {
                this.visibleSource.next(visible);
                this.dwVisibleChange.emit(visible);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThemeComponent.prototype, "dwTrigger", {
        get: function () {
            return this._trigger;
        },
        set: function (value) {
            this._trigger = value;
            this._hasBackdrop = this._trigger === 'click';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThemeComponent.prototype, "dwPlacement", {
        get: function () {
            return this._placement;
        },
        set: function (value) {
            if (value !== this._placement) {
                this._placement = value;
                this._positions.unshift(POSITION_MAP[this.dwPlacement]);
            }
        },
        enumerable: true,
        configurable: true
    });
    // Manually force updating current overlay's position
    ThemeComponent.prototype.updatePosition = function () {
        if (this.overlay && this.overlay.overlayRef) {
            this.overlay.overlayRef.updatePosition();
        }
    };
    ThemeComponent.prototype.onPositionChange = function ($event) {
        for (var key in POSITION_MAP) {
            if (JSON.stringify($event.connectionPair) === JSON.stringify(POSITION_MAP[key])) {
                this.dwPlacement = key;
                break;
            }
        }
        this.setClassMap();
        /** TODO may cause performance problem */
        this.cdr.detectChanges();
    };
    ThemeComponent.prototype.show = function () {
        if (!this.isContentEmpty()) {
            this.dwVisible = true;
        }
    };
    ThemeComponent.prototype.hide = function () {
        this.dwVisible = false;
    };
    ThemeComponent.prototype._afterVisibilityAnimation = function (e) {
        if (e.toState === 'false' && !this.dwVisible) {
            this.dwVisibleChange.emit(false);
        }
        if (e.toState === 'true' && this.dwVisible) {
            this.dwVisibleChange.emit(true);
        }
    };
    ThemeComponent.prototype.setClassMap = function () {
        var _a;
        this._classMap = (_a = {},
            _a[this.dwOverlayClassName] = true,
            _a[this._prefix + "-" + this._placement] = true,
            _a);
    };
    ThemeComponent.prototype.setOverlayOrigin = function (origin) {
        this.overlayOrigin = origin;
    };
    ThemeComponent.prototype.isContentEmpty = function () {
        // Pity, can't detect whether dwTemplate is empty due to can't get it's content before shown up
        return this.isTitleString ? (this.dwTitle === '' || !isNotNil(this.dwTitle)) : false;
    };
    Object.defineProperty(ThemeComponent.prototype, "dwPopWidth", {
        get: function () {
            return this._dwPopWidth;
        },
        set: function (val) {
            this._dwPopWidth = val;
            this.listWidth = this.dwPopWidth / this.dwColorColSplit;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThemeComponent.prototype, "dwColorColSplit", {
        get: function () {
            return this._dwColorColSplit;
        },
        set: function (val) {
            this._dwColorColSplit = val;
            this.listWidth = this.dwPopWidth / this.dwColorColSplit;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThemeComponent.prototype, "themeList", {
        get: function () {
            return this._themeList;
        },
        set: function (val) {
            var idx = val.findIndex(function (v) { return v.id === 'default'; });
            if (idx !== -1) {
                this._themeList = val;
            }
            else {
                this._themeList = this._themeList.concat(val);
            }
            // this._themeList.forEach(i => {
            //   i.showDesc = this.dwShowDesc;
            // });
        },
        enumerable: true,
        configurable: true
    });
    ThemeComponent.prototype.changeTheme = function (theme) {
        var _this = this;
        if (theme.id === 'default') {
            this.removeOtherThemeStyle();
            this.nowThemeStyleId = 'default';
            return;
        }
        var regEx = /([^\/]+)\.css/g;
        var match = regEx.exec(theme.path);
        if (!!match) {
            var elem = document.querySelector('#' + match[1]);
            if (!elem) {
                this.removeOtherThemeStyle();
                this.http.get(theme.path, { responseType: 'text' })
                    .subscribe(function (res) {
                    var css = res;
                    var head = document.head || document.getElementsByTagName('head')[0];
                    var style = document.createElement('style');
                    style.id = _this.prefix + match[1];
                    style.type = 'text/css';
                    style.appendChild(document.createTextNode(css));
                    head.appendChild(style);
                    _this.nowThemeStyleId = match[1];
                });
            }
        }
    };
    ThemeComponent.prototype.removeOtherThemeStyle = function () {
        var elems = document.querySelectorAll('style');
        var head = document.head || document.getElementsByTagName('head')[0];
        if (elems.length) {
            for (var i = 0; i < elems.length; i++) {
                if (!!elems[i].id && elems[i].id.search(this.prefix) !== -1) {
                    head.removeChild(elems[i]);
                }
            }
        }
    };
    return ThemeComponent;
}());
export { ThemeComponent };
